import { css } from 'styled-components';

import { mobile } from '../../../techstyle-shared/react-components';

import { fontStacks } from './fonts';

export const baseFontSize = 16;

const subHeaderSharedValues = css`
  font-family: 'Plain', 'Helvetica Neue', 'Helvetica', sans-serif;
  font-weight: 600;
`;

const subHeaderUppercaseSharedValues = css`
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const sharedLinkStyles = css`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.palette.gunmetal};
  transition: border-bottom linear 300ms;
  text-decoration: none;

  &:disabled {
    border: none;
    opacity: 50%;
    cursor: not-allowed;
  }
`;

const sharedNavigationLinkStyles = css`
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${({ theme }) => theme.colors.palette.black};
    color: ${({ theme }) => theme.colors.palette.black};
  }
`;

const sharedParagraphStyles = css`
  font-weight: 400;
`;
const sharedUppercaseParagraphStyles = css`
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const values = {
  display1: css`
    font-size: 72px;
    line-height: ${80 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.copy};
  `,
  display2: css`
    font-size: 64px;
    line-height: ${72 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.copy};
  `,
  heading1: css`
    font-size: 48px;
    line-height: ${56 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};

    ${mobile`
      font-size: 32px;
      line-height: ${40 / baseFontSize};
    `}
  `,
  heading1small: css`
    font-size: 32px;
    line-height: ${40 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading1: css`
    ${subHeaderSharedValues}
    font-size: 20px;
    line-height: 1.4;
  `,
  subHeading1Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}
    line-height: 1.2;
    font-size: 20px;
  `,
  heading2: css`
    font-size: 40px;
    line-height: ${48 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};

    ${mobile`
      font-size: 28px;
      line-height: ${32 / baseFontSize};
    `}
  `,
  heading2small: css`
    font-size: 28px;
    line-height: ${32 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading2: css`
    ${subHeaderSharedValues}
    font-size: 16px;
    line-height: 1.5;
  `,
  subHeading2Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}
    font-size: 16px;
    line-height: 1.25;
  `,
  heading3: css`
    font-size: 28px;
    line-height: ${32 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};

    ${mobile`
      font-size: 24px;
      line-height: ${32 / baseFontSize};
    `}
  `,
  heading3small: css`
    font-size: 24px;
    line-height: ${32 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading3: css`
    ${subHeaderSharedValues}
    font-size: 14px;
    line-height: ${20 / 14};
  `,
  subHeading3Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}
    font-size: 14px;
    line-height: ${18 / 14};
  `,
  heading4: css`
    font-size: 28px;
    line-height: ${32 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};

    ${mobile`
      font-size: 20px;
      line-height: ${24 / baseFontSize};
    `}
  `,
  heading4small: css`
    font-size: 20px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading4: css`
    ${subHeaderSharedValues}
    font-size: 12px;
    line-height: ${24 / baseFontSize};
  `,
  subHeading4Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}
    font-size: 12px;
    line-height: ${21 / baseFontSize};
  `,
  heading5: css`
    font-size: 24px;
    line-height: ${32 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};

    ${mobile`
      font-size: 16px;
      line-height: ${24 / baseFontSize};
    `}
  `,
  heading5small: css`
    font-size: 16px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading5: css`
    ${subHeaderSharedValues}
    font-size: 10px;
    line-height: 1.4;
  `,
  subHeading5small: css`
    font-size: 16px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.subheadings};
  `,
  subHeading5Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}
    font-size: 10px;
    line-height: 1.4;
  `,
  heading6: css`
    font-size: 20px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  heading6Uppercase: css`
    font-family: ${fontStacks.headings};
    font-size: 20px;
    font-weight: 400;
    line-height: ${32 / baseFontSize};
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  heading6small: css`
    font-size: 14px;
    line-height: ${18 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading6smallUppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}

    font-family: ${fontStacks.subheadings};
    font-size: 14px;
    line-height: ${24 / baseFontSize};
  `,
  heading7: css`
    font-family: ${fontStacks.headings};
    font-size: 18px;
    font-weight: 400;
    line-height: ${32 / baseFontSize};
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  subHeading7smallUppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}

    font-family: ${fontStacks.subheadings};
    font-size: 16px;
    line-height: 1.2;
  `,
  heading8: css`
    font-size: 12px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.headings};
  `,
  subHeading8: css`
    font-size: 12px;
    line-height: ${24 / baseFontSize};
    font-weight: bold;
    font-family: ${fontStacks.subheadings};
  `,
  subHeading8Uppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}

    font-size: 12px;
    line-height: 1;
    font-family: ${fontStacks.subheadings};
  `,
  subHeading8small: css`
    ${subHeaderSharedValues}

    font-family: ${fontStacks.headings};
    font-size: 10px;
    line-height: 1.2;
  `,
  subHeading8smallUppercase: css`
    ${subHeaderSharedValues}
    ${subHeaderUppercaseSharedValues}

    font-family: ${fontStacks.subheadings};
    font-size: 10px;
    line-height: 1.2;
  `,
  paragraph6: css`
    ${sharedParagraphStyles}

    font-size: 20px;
    line-height: 2.3;
  `,
  paragraph6Uppercase: css`
    ${sharedParagraphStyles}
    ${sharedUppercaseParagraphStyles}

    font-size: 20px;
    line-height: 2.3;
  `,
  paragraph5: css`
    ${sharedParagraphStyles}

    font-size: 18px;
    line-height: 2.15;
  `,
  paragraph4: css`
    ${sharedParagraphStyles}

    font-size: 16px;
    line-height: ${32 / baseFontSize};
  `,
  paragraph4Uppercase: css`
    ${sharedParagraphStyles}
    ${sharedUppercaseParagraphStyles}

    font-size: 16px;
    line-height: ${32 / baseFontSize};
  `,
  paragraph3: css`
    font-size: 14px;
    line-height: ${24 / baseFontSize};
    font-family: ${fontStacks.copy};
  `,
  paragraph3Uppercase: css`
    font-size: 14px;
    line-height: 1.65;
    font-family: ${fontStacks.copy};
    text-transform: uppercase;
    letter-spacing: 1px;
  `,
  paragraph2: css`
    font-size: 12px;
    line-height: ${20 / baseFontSize};
    font-family: ${fontStacks.copy};
  `,
  paragraph2Uppercase: css`
    ${sharedParagraphStyles}
    ${sharedUppercaseParagraphStyles}

    font-size: 12px;
    line-height: ${20 / baseFontSize};
    font-family: ${fontStacks.copy};
  `,
  paragraph1: css`
    font-size: 10px;
    line-height: ${18 / baseFontSize};
    font-family: ${fontStacks.copy};
  `,
  paragraph1Uppercase: css`
    ${sharedParagraphStyles}
    ${sharedUppercaseParagraphStyles}

    font-size: 10px;
    line-height: 1.2;
    font-family: ${fontStacks.copy};
  `,
  caption: css`
    font-size: 12px;
    line-height: ${24 / baseFontSize};
    font-family: ${fontStacks.copy};
  `,
};

const variants = {
  accountConfirmationHeader: {
    textStyle: css`
      ${values.heading2}
      font-weight: bold;
    `,
  },
  accountConfirmationSubheader: {
    textStyle: values.paragraph2,
  },
  accountGreetingRewardsLabel: {
    textStyle: values.caption,
  },
  accountGreetingRewardsValue: {
    textStyle: css`
      font-weight: 600;
    `,
  },
  accountSectionHeader: {
    textStyle: values.heading6,
  },
  accountBoxInfoLabel: {
    textStyle: css`
      ${sharedParagraphStyles}
      ${sharedUppercaseParagraphStyles}
      font-size: 14px;
      line-height: 1.3;
    `,
  },
  accountBoxInfoText: {
    textStyle: css`
      ${sharedParagraphStyles}
      ${sharedUppercaseParagraphStyles}
      font-size: 14px;
      line-height: 1.3;
    `,
  },
  bodyMed: {
    textStyle: values.paragraph2,
  },
  bodyMedEmphasized: {
    textStyle: css`
      ${values.paragraph2};
      font-weight: 700;
    `,
  },
  errorText: {
    textStyle: css`
      ${values.paragraph1};
      font-weight: 700;
    `,
  },
  embroideryModalHeader: {
    textStyle: values.heading6,
  },
  embroideryModalCounter: {
    textStyle: values.paragraph1,
  },
  formLabelEmphasized: {
    textStyle: css`
      ${values.heading5small};
      letter-spacing: -0.02em;
      line-height: ${24 / 16};
    `,
  },
  cardHeader: {
    textStyle: values.heading6,
  },
  cardEmphasized: {
    textStyle: values.heading8,
  },
  cardBody: {
    textStyle: css`
      ${values.caption};
      font-weight: 400;
    `,
  },
  cardBodyMed: {
    textStyle: css`
      ${values.paragraph1};
      font-weight: 400;

      ${mobile`
        font-weight: 600;
      `}
    `,
  },
  cardBodyHeavy: {
    textStyle: css`
      ${values.caption};
      font-weight: 600;
    `,
  },
  cardBodyLg: {
    textStyle: css`
      ${values.paragraph3}
      font-weight: 600;
      line-height: ${23 / 18};

      ${mobile`
      ${values.paragraph2}
        font-weight: 700;
        line-height: ${24 / 16};
      `}
    `,
  },
  characterCountLabel: {
    textStyle: css`
      ${values.caption};
      font-weight: 600;
    `,
  },
  contactFormHeader: {
    textStyle: css`
      ${values.heading3}
      font-weight: 700;
    `,
  },
  contactFormOptIn: {
    textStyle: values.paragraph1,
  },
  gridTabOffer: {
    textStyle: css`
      ${values.heading2small};
      font-weight: 700;
      display: block;
      text-align: center;
      margin-bottom: 20px;
    `,
  },
  gridEmphasized: {
    textStyle: css`
      font-weight: 400;
    `,
  },
  headlineLarge: {
    textStyle: css`
      ${values.heading1}
      font-weight: 700;

      ${mobile`
        font-size: 48px;
        line-height: ${60 / 48};
        font-weight: 600;
      `}
    `,
  },
  headlineMedium: {
    textStyle: values.heading3,
  },
  iconLabel: {
    textStyle: values.heading8,
  },
  inlineFigureTitle: {
    textStyle: css`
      ${values.heading3small}
      color: ${({ theme }) => theme.colors.textEmphasized};
    `,
  },
  inlineFigureBody: {
    textStyle: css`
      ${values.paragraph2}
      font-weight: 400;
      color: ${({ theme }) => theme.colors.textEmphasized};
    `,
  },
  displayFieldLabel: {
    textStyle: css`
      ${values.paragraph2}
      color: ${({ theme }) => theme.colors.textDefault};
    `,
  },
  displayFieldValue: {
    textStyle: css`
      ${values.paragraph2}
      color: ${({ theme }) => theme.colors.textDefault};
      font-weight: 600;
    `,
  },
  embroideryNotification: {
    textStyle: css`
      ${values.caption}
    `,
  },
  labelUnstyled: {
    textStyle: css`
      ${values.subHeading5small}
      font-weight: 600;

      ${mobile`
        font-size: 12px;
      `}
    `,
  },
  linkDeemphasized: {
    textStyle: css`
      ${values.caption};
      font-weight: 600;
      color: ${({ theme }) => theme.colors.linkTextDeemphasized};
    `,
  },
  linkUnstyled: {
    textStyle: values.paragraph1,
  },
  linkEmphasized: {
    textStyle: css`
      ${values.subHeading5small}
      padding-bottom: 4px;
      font-weight: 600;
      border-bottom: 2px solid ${({ theme }) => theme.colors.textDefault};

      ${mobile`
        font-size: 12px;
      `}
    `,
  },
  linkSpeedyTermsAndPrivacy: {
    textStyle: css`
      ${values.caption};
      color: ${({ theme }) => theme.colors.linkTextSpeedyTermsAndPrivacy};
    `,
  },
  listItemHeading: {
    textStyle: css`
      ${values.heading5small};
      margin-bottom: 8px;
    `,
  },

  miniCartPreOrderLabel: {
    textStyle: css`
      ${values.heading8};
      font-weight: 600;
      color: ${({ theme }) => theme.colors.white};
    `,
  },
  miniCartTitle: {
    textStyle: css`
      ${values.paragraph1}
      color: ${({ theme: { colors } }) => colors.textDefault};
      font-weight: 600;
    `,
  },
  miniCartEmptyMessage: {
    textStyle: css`
      ${values.heading5}
      font-weight: 700;
      color: ${({ theme }) => theme.colors.textDefault};
    `,
  },
  miniCartSubEmptyMessage: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 400;
      color: ${({ theme }) => theme.colors.textDefault};
    `,
  },
  miniCartFreeShippingCallout: {
    textStyle: css`
      ${values.caption}
      font-weight: 600;
      color: ${({ theme }) => theme.colors.textDeemphasizedAlternate};
    `,
  },
  miniCartError: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 600;
    `,
  },
  miniCartRemoveItemError: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 600;
    `,
  },
  miniCartBundleToggle: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 600;
    `,
  },
  miniCartScarcityNotice: {
    textStyle: css`
      ${values.caption}
      font-weight: 600;
    `,
  },
  miniCartScarcityCallout: {
    textStyle: css`
      ${values.paragarph1}
      font-weight: 600;
    `,
  },
  miniCartQuality: {
    textStyle: css`
      ${values.caption}
      font-weight: 400;
    `,
  },

  miniCartTimerPromoTitle: {
    textStyle: css`
      ${values.paragraph2}
      font-weight: 700;
      color: ${({ theme }) => theme.colors.textLight};
    `,
  },
  miniCartTimerPromoOffer: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 600;
      color: ${({ theme }) => theme.colors.textLight};
    `,
  },
  miniCartTimerHeader: {
    textStyle: css`
      ${values.caption}
      color: ${({ theme }) => theme.colors.textLight};
    `,
  },
  miniCartTimerWrapper: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 700;
      color: ${({ theme }) => theme.colors.textLight};
    `,
  },
  modalCallout: {
    textStyle: values.heading5small,
  },
  modalHeader: {
    textStyle: css`
      ${values.heading3small}
      text-align: center;
    `,
  },
  modalSubheader: {
    textStyle: css`
      ${values.subHeading5small}
      font-weight: 600;
      text-align: center;
    `,
  },
  orderDetailsHeading: {
    textStyle: css`
      ${values.subHeading5small};
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: ${18 / baseFontSize};
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.gunmetal};
    `,
  },
  orderDetailsText: {
    textStyle: css`
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 1px;
      line-height: ${18 / baseFontSize};
      text-transform: uppercase;
      font-family: ${fontStacks.copy};
      color: ${({ theme }) => theme.colors.accountOrderDetailsLineItem};
    `,
  },
  orderSummaryText: {
    textStyle: css`
      letter-spacing: 1px;
      line-height: ${18 / baseFontSize};
      text-transform: uppercase;
      font-family: ${fontStacks.copy};
    `,
  },
  orderHistoryText: {
    textStyle: css`
      letter-spacing: 1px;
      line-height: ${18 / baseFontSize};
      text-transform: uppercase;
      font-family: ${fontStacks.copy};
    `,
    dataColumn: css`
      font-size: 10px;
    `,
  },
  reviewsLayoutText: {
    textStyle: css`
      letter-spacing: 1px;
      line-height: ${18 / baseFontSize};
      text-transform: uppercase;
      font-family: ${fontStacks.copy};
    `,
  },
  orderVipSavings: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 700;
    `,
  },
  orderedListSectionSubtitle: {
    textStyle: css`
      ${values.heading3small}
      font-weight: 700;
    `,
  },
  orderedListSectionTitle: {
    textStyle: css`
      ${values.heading3}
      font-weight: 600;
      color: ${({ theme }) => theme.colors.textDeemphasizedAlternate};
    `,
  },
  postRegGridTab: {
    textStyle: values.paragraph2,
  },
  postRegTabCountDownTimer: {
    textStyle: css`
      ${values.heading6}
      font-weight: 600;
    `,
  },
  legacyPostregCountdownTimer: {
    textStyle: css``,
  },
  productRatingCount: {
    textStyle: css`
      ${values.paragraph1}
      color: ${({ theme }) => theme.colors.linkText};
    `,
  },
  productCellTitle: {
    textStyle: css`
      ${values.heading5small}
    `,
  },
  productCellBody: {
    textStyle: css`
      ${values.paragraph1}
    `,
  },
  productCellBodyEmphasized: {
    textStyle: css`
      ${values.paragraph1}
      font-weight: 600;
      line-height: ${18 / 14};
    `,
  },
  productCellProductName: {
    textStyle: css`
      ${sharedUppercaseParagraphStyles}
      ${values.paragraph2}
      color: ${({ theme }) => theme.colors.palette.gunmetal};
      font-weight: 400;
      line-height: 1.3;
    `,
  },
  productCellPrice: {
    textStyle: css`
      color: ${({ theme }) => theme.colors.palette.stone400};
      ${sharedParagraphStyles}
      ${values.paragraph3}
      line-height: 1.3;
      letter-spacing: 1px;
      text-transform: uppercase;
    `,
  },
  productCellPromoPrice: {
    textStyle: css`
      color: ${({ theme }) => theme.colors.palette.gunmetal900};
      ${sharedParagraphStyles}
      ${values.paragraph3}
      font-weight: 600;
      line-height: 1.3;
      letter-spacing: 1px;
      text-transform: uppercase;
    `,
  },
  productCellCallout: {
    textStyle: css`
      ${values.paragraph2}
      font-weight: 700;
      line-height: 1.5;
      text-transform: uppercase;
    `,
  },
  productDetailVatDisclaimer: {
    textStyle: css`
      font-size: 14px;
      margin-top: 16px;
      color: ${({ theme }) => theme.colors.palette.stone400};
    `,
  },
  quizAnswer: {
    textStyle: css`
      ${values.heading8};
      line-height: 1.1;
      font-weight: 700;
    `,
  },
  quizSizeBlock: {
    textStyle: css`
      ${values.paragraph2};
      font-weight: 600;
    `,
  },
  quizPageHeader: {
    textStyle: values.heading6,
  },
  quizPageSubHeader: {
    textStyle: values.paragraph1,
  },
  quizSkippedText: {
    textStyle: values.paragraph2,
  },
  quizStepCounter: {
    textStyle: css`
      ${values.paragraph1};
      font-weight: 600;
    `,
  },
  sectionTitle: {
    textStyle: css`
      ${values.heading3small};
      text-align: center;
      color: ${({ theme }) => theme.colors.textEmphasized};
    `,
  },
  sectionHeader: {
    textStyle: css`
      ${values.heading3small};
      font-weight: 600;
      text-align: center;
    `,
  },
  sectionBody: {
    textStyle: css`
      ${values.paragraph3};
      text-align: center;
    `,
  },
  sectionText: {
    textStyle: values.paragraph2,
  },
  sustainabilityFeature: {
    textStyle: css`
      ${values.paragraph3}
      line-height: 28px;
    `,
  },
  sizeGuideHeader: {
    textStyle: values.heading5,
  },
  sizeGuideSubheader: {
    textStyle: values.heading5small,
  },
  sizeGuideText: {
    textStyle: values.paragraph1,
  },
  sizeGuideCaption: {
    textStyle: values.caption,
  },
  splashPageDate: {
    textStyle: css`
      ${values.heading2small}
      font-weight: normal;
    `,
  },
  splashPageHeader: {
    textStyle: css`
      ${values.heading3}
      font-weight: 600;
    `,
  },
  splashPageSubheader: {
    textStyle: values.paragraph3,
  },
  splashPageOptIn: {
    textStyle: values.paragraph1,
  },
  splashPageEarlyAccess: {
    textStyle: values.paragraph3,
  },
  splashPageThanks: {
    textStyle: css`
      ${values.heading1small}
      font-weight: 600;
    `,
  },
  splashPageEarlyAccessModalHeader: {
    textStyle: css`
      ${values.paragraph3}
      font-weight: 700;
    `,
  },
  termsText: {
    textStyle: css`
      ${values.caption}
    `,
  },
  secondaryLink: {
    textStyle: css`
      ${sharedLinkStyles}
      ${sharedNavigationLinkStyles}
      ${values.paragraph2Uppercase}
    `,
  },
  checkout: {
    itemInformation: {
      textStyle: css`
        ${values.paragraph2Uppercase}

        line-height: 1.5;
      `,
    },
  },
  default: {
    // WARNING: for deprecated `fontVariant` use only. Please do not use for other use cases.
    textStyle: css`
      font-family: ${fontStacks.baseFamily};
      text-transform: uppercase;
    `,
  },
};

export const typography = {
  values,
  variants,
};
